"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var OverLay = function OverLay(props) {
  var darkOverlay = props.darkOverlay,
    isOpen = props.isOpen;
  var onClickAction = (props == null ? void 0 : props.onClickAction) || null;
  var className = darkOverlay ? 'overlay-container' : 'overlay-container--light';
  var getContent = function getContent() {
    return isOpen ? _react.default.createElement("div", {
      className: className,
      onClick: onClickAction
    }) : _react.default.createElement(_react.default.Fragment, null);
  };
  return _react.default.createElement(_react.default.Fragment, null, getContent());
};
OverLay.defaultProps = {
  darkOverlay: true
};
var _default = OverLay;
exports.default = _default;
module.exports = exports["default"];